import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useConfig } from '../context/ConfigContext';
import faviconImg from '../assets/images/otter.png';

const Header = ({ onReportClick }) => {
  const { language, toggleLanguage, t } = useLanguage();
  const { showAddWetlandFab } = useConfig();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // Only check user agent - this cannot be spoofed by resizing browser window
      const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
      return isMobileDevice;
    };
    setIsMobile(checkMobile());
  }, []);

  return (
    <header className="app-header">
      <h1>
        <img src={faviconImg} alt="Logo" className="logo-img" />
        <span className="desktop-only">{t('appName')}</span>
        <span className="mobile-only">wetlands.rs</span>
      </h1>
      <div className="header-actions">
        <button className="language-toggle" onClick={toggleLanguage}>
          {language === 'lat' ? 'Ћирилица' : 'Latinica'}
        </button>
        {isMobile && showAddWetlandFab && (
          <button className="report-button mobile-only" onClick={onReportClick}>
            {t('Pošalji')}
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
